import { type GoogleIntegrationStatusData } from "./api";

export type GoogleIntegrationViewState = "loading" | "not_connected" | "connected" | "scope_missing" | "error";

export type GoogleIntegrationView = {
  state: GoogleIntegrationViewState;
  connectionStatus?: string;
  scopeBundleGranted: boolean;
  missingScopes: string[];
  email?: string;
  connectedAt?: string;
  lastError?: string | null;
};

export function normalizeGoogleIntegrationStatus(data: GoogleIntegrationStatusData): GoogleIntegrationView {
  const missingScopes = Array.isArray(data.missingScopes) ? data.missingScopes : [];
  const connectionStatus = (data.connectionStatus ?? "").trim();
  const activeConnectionMetadata = {
    email: data.email,
    connectedAt: data.connectedAt,
  };

  if (data.scopeBundleGranted) {
    return {
      state: "connected",
      connectionStatus,
      scopeBundleGranted: true,
      missingScopes,
      ...activeConnectionMetadata,
      lastError: data.lastError,
    };
  }

  if (connectionStatus.toLowerCase() === "active") {
    return {
      state: "scope_missing",
      connectionStatus,
      scopeBundleGranted: false,
      missingScopes,
      ...activeConnectionMetadata,
      lastError: data.lastError,
    };
  }

  return {
    state: "not_connected",
    connectionStatus,
    scopeBundleGranted: false,
    missingScopes,
    lastError: data.lastError,
  };
}

export function getGoogleIntegrationStatusLabel(status: GoogleIntegrationView) {
  switch (status.state) {
    case "connected":
      return "連携済み";
    case "scope_missing":
      return "権限不足";
    case "error":
      return "確認失敗";
    case "loading":
      return "確認中";
    default:
      return "未連携";
  }
}

export function getGoogleIntegrationStatusDescription(status: GoogleIntegrationView) {
  switch (status.state) {
    case "connected":
      return "Google機能を利用できます。";
    case "scope_missing":
      return "必要な権限が不足しています。再連携してください。";
    case "error":
      return "連携状態を確認できませんでした。";
    case "loading":
      return "連携状態を確認しています。";
    default:
      return "Google機能を使うには連携が必要です。";
  }
}

export function getGoogleIntegrationActionLabel(status: GoogleIntegrationView) {
  switch (status.state) {
    case "connected":
      return "確認する";
    case "scope_missing":
      return "再連携";
    case "error":
      return "再試行";
    case "loading":
      return "確認中";
    default:
      return "連携する";
  }
}
